import { Permission } from '@Constants/Permission.g';
import { useHasPermission } from '@Contexts/appContext';
import { useTableMode } from '@Hooks/useTableModes';
import { type SelectOption, SingleSelect, type ToolbarOptions } from '@synqo/frontend-component-library';
import { useCallback } from 'react';
import { FrameListExportRuns } from '@Modules/Documents';
import { ArchiveList } from './ArchiveList';

type DownloadsMode = 'archives' | 'exports';

const downloadsModes: SelectOption<DownloadsMode>[] = [
    { name: 'archives', label: 'ZIP-Downloads', value: 'archives' },
    { name: 'exports', label: 'Excel-Exporte', value: 'exports' },
];

const REQUIRED: Record<DownloadsMode, Permission> = {
    archives: Permission.DocumentsDocumentRead,
    exports: Permission.DocumentsDynamicExportRunRead,
};

/** The caller's ZIP downloads and export runs, one view at a time. */
// @ai-generated 2026-10-01T05:46:19+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5 (1M context)
export function FrameListDownloads() {
    const hasPermission = useHasPermission();
    const mayOpen = useCallback((mode: DownloadsMode) => hasPermission(REQUIRED[mode]), [hasPermission]);
    const defaultMode = mayOpen('archives') ? 'archives' : 'exports';
    const { tableModeValue, setTableMode, availableTableModes } = useTableMode(defaultMode, downloadsModes, mayOpen);

    const toolbarElements = useCallback(
        (elements: ToolbarOptions[]) => [
            ...elements,
            <SingleSelect<DownloadsMode>
                key="tableMode"
                name="tableMode"
                items={availableTableModes}
                value={tableModeValue}
                onChange={setTableMode}
            />,
        ],
        [availableTableModes, tableModeValue, setTableMode],
    );

    return tableModeValue === 'exports' ? (
        <FrameListExportRuns toolbarElements={toolbarElements} />
    ) : (
        <ArchiveList toolbarElements={toolbarElements} />
    );
}
